var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialWechatSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#5BC78C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.678 20.001c-5.559-.08-10.178 3.839-10.178 8.46 0 2.668 1.308 4.983 3.84 6.682 0 0-.928 2.938-.915 2.997.013.059.215.174.285.137.07-.038 3.355-1.917 3.355-1.917 2.353.775 3.79.584 4.034.552l.034-.004a5.888 5.888 0 01-.229-2.84c.982-5.42 6.765-7.105 9.935-6.817-.875-3.914-4.677-7.17-10.16-7.25zm-3.864 4.448c-.729 0-1.32.567-1.32 1.267s.591 1.267 1.32 1.267c.73 0 1.32-.567 1.32-1.267s-.59-1.267-1.32-1.267zm7.993 0c-.729 0-1.32.567-1.32 1.267s.591 1.267 1.32 1.267c.73 0 1.32-.567 1.32-1.267s-.59-1.267-1.32-1.267z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.976 34.892c0-3.959-3.991-6.992-8.622-6.992-4.902 0-8.813 3.102-8.813 7.06 0 3.967 3.72 7.25 8.82 7.278 1.025.005 2.554-.248 3.585-.66 0 0 2.464 1.432 2.602 1.422a.223.223 0 00.214-.205c.006-.09-.785-2.328-.785-2.328 2.116-1.59 3-3.341 3-5.575zm-11.849-3.707c-.645 0-1.168.503-1.168 1.123s.523 1.123 1.168 1.123c.646 0 1.169-.503 1.169-1.123s-.523-1.122-1.169-1.122zm6.247 0c-.645 0-1.168.503-1.168 1.123s.523 1.123 1.168 1.123c.645 0 1.168-.503 1.168-1.123s-.523-1.122-1.168-1.122z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 63.5,
    height: 63.5,
    rx: 9.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}
export default SvgSocialWechatSquare;